// extracted by mini-css-extract-plugin
module.exports = {"container":"Event_container__3hQ9u","mainContent":"Event_mainContent__oRKfO"};